import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {getAllVerifyResponse, getUserInfo} from "../store/logIn";

function Header(props){
    const navigate = useNavigate()

    useEffect(()=>{
        const token = localStorage.getItem('token');
        if (token !== 'undefined'){
            const data = {"token": JSON.parse(token)}
            props.getAllVerifyResponse(data)
        }
        props.getUserInfo()
    }, [])

    useEffect(()=>{
        if (props.verify===false){
            navigate("/login/");
        }
        if (props.user.is_main !== undefined) {
            localStorage.setItem('is_main', JSON.stringify(props.user.is_main));
            localStorage.setItem('user_id', JSON.stringify(props.user.id || 0));
        }
        if (props.user.display_name !== undefined) {
            localStorage.setItem('user_name', JSON.stringify(props.user.display_name || ''));
        }
    }, [props])

    return <div><div className="loader"/></div>
}
export default connect(props=>props.login, {getAllVerifyResponse, getUserInfo})(Header)
